import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import { FaRuler } from 'react-icons/fa';
import { SoilCore } from '../../db';
import ManualMeasurementsChecker, { ManualMeasurementDialogParameters } from '../../services/ManualMeasurementsChecker';
import { dispatchMissionUpdated } from '../../missionEvents';
import { dispatchSamplesUpdated } from '../../mapEvents';

type Props = {
  cores: SoilCore[];
  openManualMeasurementDialog: (params: ManualMeasurementDialogParameters) => void;
};

const CoresList = ({ cores, openManualMeasurementDialog }: Props) => {
  if (cores.length === 0) {
    return null;
  }

  const onCoreClick = async (core: SoilCore) => {
    await new ManualMeasurementsChecker().check(openManualMeasurementDialog, core, true);

    dispatchMissionUpdated();
    // Only the core's parent sample changed — use a targeted rebuild
    // instead of the full CorePointsLayer.rebuildAll() path.
    const sampleId = core.getSample()?.sample_id;

    if (sampleId) {
      dispatchSamplesUpdated([sampleId]);
    }
  };

  const sortedCores = cores.slice().sort((c1, c2) => c1.core_number - c2.core_number);

  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {sortedCores.map((core) => {
        const labelId = `checkbox-list-label-${core._instance_id}`;

        return (
          <ListItem
            key={core._instance_id}
            disablePadding
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="core-length-measurements"
                onClick={() => onCoreClick(core)}
                size="large"
              >
                <FaRuler />
              </IconButton>
            }
          >
            <ListItemButton dense onClick={() => onCoreClick(core)}>
              <ListItemText
                id={labelId}
                primary={`Core ${core.core_number}, ${core.pulled ? 'PULLED' : 'NOT PULLED'}, length ${
                  core.core_length_cm
                } (cm)`}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default CoresList;
